<template>
    <chart-container>
        <i slot="chart-header">{{ chartTitle }}</i>
        <div slot="chart-body">
            <loading-indicator v-if="loading" />
            <p v-else-if="sessionsInfo.length === 0">No results found.</p>
            <table-chart v-else :chart-data="chartData" :options="chartOptions" />
            <button @click="handleNext" :disabled="!endCursor || loadingMore">Retrieve More</button>
        </div>
    </chart-container>
</template>

<script>
import { get, map } from 'lodash';
import ChartContainer from './chartContainer.vue';
import LoadingIndicator from '../loadingIndicator.vue';
import TableChart from './tableChart.vue';
import AdvancedInsights from '../../models/advancedInsights.js';

import VueApollo from 'vue-apollo';

export default {
    name: 'UsageBySession',
    components: { ChartContainer, LoadingIndicator, TableChart },
    props: {
        apollo: {
            type: VueApollo,
            required: true
        },
        videoApiKey: {
            type: String,
            required: true
        },
        daysAgo: {
            type: Number,
            required: false
        },
        refresh: {
            type: Number,
            required: false,
            default: 5
        },
        noRefresh: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            advancedInsights: new AdvancedInsights(this.videoApiKey, this.daysAgo),
            chartTitle: '',
            chartData: {},
            chartOptions: {},
            loading: true,
            endCursor: '',
            loadingMore: false,
            totalCount: 0,
            sessionsInfo: [],
        };
    },
    async mounted() {
        this.loading = true;
        await this.getSessionsInfo();
    },
    methods: {
        async getSessionsInfo() {
            const sessionSummariesQuery = this.advancedInsights.queries.usageSessionSummaries(this.endCursor);
            const sessionResults = await this.apollo.defaultClient.query({ query: sessionSummariesQuery });
            const { totalCount, pageInfo } = sessionResults.data.project.sessionData.sessionSummaries;

            this.endCursor = pageInfo.endCursor || '';
            this.totalCount = totalCount;

            const sessions = get(sessionResults.data, 'project.sessionData.sessionSummaries.resources', []);
            const sessionIds = map(sessions, session => `"${session.sessionId}"`);

            const query = this.advancedInsights.queries.usageBySession(sessionIds);
            const results = await this.apollo.defaultClient.query({ query });
            const resources = get(results.data, 'project.sessionData.sessions.resources', []);
            this.sessionsInfo = this.sessionsInfo.concat(resources);

            const chartDataObject = this.advancedInsights.chartData.usageBySession(this.sessionsInfo);
            this.chartData = chartDataObject.data;
            this.chartTitle = chartDataObject.title;
            this.chartOptions = chartDataObject.options;

            this.loading = false;
        },
        async handleNext() {
            this.loadingMore = true;
            await this.getSessionsInfo();
            this.loadingMore = false;
        },
    }
}
</script>

<style scoped>
</style>
